import React from 'react';
import get from 'lodash/get';
import {
  Image,
  Button,
  Section
} from '../../../../fc-components/main/components';

export const SplashPage = props => {
  const franchise_name = get(props, 'franchise_name','');
  const release_date = get(props, 'release_date', '');
  const previous_years_text = get(props, 'previous_years', '');
  const previous_year_url = get(props, 'previous_franchise_year_url', '');
  const apply_text = get(props, 'apply_text','');
  const apply_url = get(props, 'apply_url', '');
  const logo_url = get(props, 'logo.url', '');
  const splash_page_type = get(props, 'splash_page_type', '');
  let franchise_color = false;
  let bgColor = false;
  let hover = false;
  let hover_color = false;
  let labelColor = false;

  switch(splash_page_type) {

    case('mic-2023'):
      franchise_color = '#00C2FF';
      bgColor = '#FDEC07';
      hover = '#fff';
      hover_color = '#000';
      break;

    case('wci-2023'):
      franchise_color = '#FC136F';
      bgColor = '#000000';
      hover = '#000000';
      labelColor = "white";
      hover_color = '#ffffff';
      break;

    default:
      franchise_color = '';
      bgColor = '';
      hover = '';
      hover_color = '';
  }


  return ( 
    <div className={`splashPageContainer ${splash_page_type}`}>
      <Section name="mainContent" bgColor={franchise_color}>
        <Image image={logo_url}/>
        <div className="comingSoon"> Coming Soon </div>
        <div className="statement"> The {franchise_name} list will be available on {release_date} </div>
        <a href={previous_year_url}>
          <Button
            bgColor={bgColor}
            labelHoverColor={hover}
            labelColor={labelColor || "black"}
            hoverColor={hover_color}
            rounded
            label={previous_years_text}
          />
        </a>
        <a className="previousLink" href={apply_url}> {apply_text} </a>
      </Section>
    </div>
  );
}
